import { USER_ROLE, type UserRole } from '@/shared/types/user';

export type TabItem = {
  label: string;
  value: 'user-management' | 'environment-settings';
  role: readonly UserRole[];
};

export const TAB_ITEMS: TabItem[] = [
  {
    label: '사용자 관리',
    value: 'user-management',
    role: [USER_ROLE.ADMIN],
  },
  {
    label: '환경설정',
    value: 'environment-settings',
    role: [USER_ROLE.ADMIN, USER_ROLE.MANAGER, USER_ROLE.USER],
  },
];

export type FilterUserType = {
  label: string;
  value: UserRole | 'all';
};

export const FILTER_USER_TYPE_OPTIONS: FilterUserType[] = [
  {
    label: '전체',
    value: 'all',
  },
  {
    label: '관리자',
    value: USER_ROLE.ADMIN,
  },
  {
    label: '편집자',
    value: USER_ROLE.MANAGER,
  },
  {
    label: '사용자',
    value: USER_ROLE.USER,
  },
];

export const INFO_USER_ROLE_TERM = {
  [USER_ROLE.ADMIN]: {
    label: '관리자',
    description: '기록서 생성 및 데이터 관리 또는 사용자 관리 가능',
  },
  [USER_ROLE.MANAGER]: {
    label: '편집자',
    description: '기록서 생성 가능',
  },
  [USER_ROLE.USER]: {
    label: '사용자',
    description: '조회만 가능',
  },
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;

export type SystemNotice = {
  id: number;
  notification_email: string;
  created_at: string;
  updated_at: string;
};
